import { Box, Button, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { icons } from "../../../../../../../../utils/icons"
import { FiltersDrawer } from "../../../../../../../../components/filtersDrawer"
import { DinamicForm } from "../../../../../../../../components/dinamicForm"
import { AddFileProps } from "./types"
import { CustomTable } from "../../../../../../../../components"
import { useContextState } from "../../../../../../../../hooks/theme"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import { LoadingButton } from "@mui/lab"



export const AddFile = ({ loadingSaveFiles, disabledAddFiles, tableAddLoading, totalPagesAddFiles, filterAddFiles, closeModal, openModal, handleAddFiles,  input, columnFileAdd, rowFileAdd, goBackToUser }: AddFileProps) => {


    const { t } = useTranslation()
    const styles = useStyles()
    const { colors } = useContextState()
    const { counter, errors, filterData, paginationModel, handlePagination, onChange, cleanFilter, sortTable, query } = filterAddFiles


    return (
        <Box >
            <FiltersDrawer cleanFilter={cleanFilter} count={counter} right={0} top={90}>
                <Box sx={styles.section}>
                    <DinamicForm errors={errors} input={Object.values(input)} values={filterData} onChange={onChange} filter={true} legacyErrors />
                </Box>
            </FiltersDrawer>

            <Box sx={styles.header}>
                <Typography sx={styles.title}>{t('filesManager.subtitles.addFile')}</Typography>

                <Box sx={styles.flex}>
                    {!!counter && <IconButton
                        sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                        onClick={() => {
                            cleanFilter()
                        }}
                    >
                        {icons('clean')}
                    </IconButton>
                    }
                </Box>
            </Box>

            <Box sx={styles.containerButtons}>
                <Button sx={styles.cancelButton} onClick={goBackToUser}>{t('general.cancel')}</Button>

                <LoadingButton loading={loadingSaveFiles} className="next" variant="contained" disabled={disabledAddFiles}
                    onClick={handleAddFiles}>
                    {t('filesManager.buttons.addFile')}
                </LoadingButton>
            </Box>

            <CustomTable
                name="Informe General"
                dontRefresh
                serverSidePagination={{ page: paginationModel.page + 1, size: paginationModel.pageSize, totalPages: totalPagesAddFiles }}
                handleChange={(page: number, pageSize: number) => {
                    handlePagination({ page, pageSize })
                }}
                order={
                    query?.sort && {
                        count: query?.sort?.count,
                        key: query?.sort?.field,
                        order: query?.sort?.sort,
                    }
                }
                sortable={(field, sort, count) => {
                    sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
                }}
                column={columnFileAdd}
                loader={tableAddLoading}
                row={rowFileAdd}
                color={colors}
                selected={-1}
            />

            <SimpleModal
                open={!!openModal.open}
                next={openModal.confirm}
                back={openModal.back}
                close={closeModal}
                description={openModal.description}
                buttonText={!!openModal.back ? t('general.confirm') : t('filesManager.buttons.continue')}
                cancelText={t('general.cancel')}
                title={openModal.title}
                loadingButton={false}
                children={openModal.children}
                sx={{
                    width: '400px'
                }}
                containerBox={{
                    sx: {
                        height: '150px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                }}
                //removeButtons={!!openModal.removeButtons}
            />


        </Box>
    )
}